import { render } from "./UpdateEmailModal.vue?vue&type=template&id=67a69369&scoped=true&lang=pug"
import script from "./UpdateEmailModal.vue?vue&type=script&lang=js"
export * from "./UpdateEmailModal.vue?vue&type=script&lang=js"

import "./UpdateEmailModal.vue?vue&type=style&index=0&id=67a69369&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a69369"]])

export default __exports__